import { withApollo } from '@apollo/client/react/hoc'
import compose from 'lodash/flowRight'
import { connect } from 'react-redux'

import { getSelectedOrdersIds } from 'store/orderList/selectors'

import ScheduleForExportModal from './ScheduleForExportModal.component'
import {
  withScheduleForExportMutation,
  withUnscheduleForExportMutation,
} from './ScheduleForExportModal.mutations'

const mapStateToProps = (state) => ({
  selectedOrderIds: getSelectedOrdersIds(state),
})

const withRedux = connect(mapStateToProps)
export default compose(
  withApollo,
  withRedux,
  withScheduleForExportMutation,
  withUnscheduleForExportMutation,
)(ScheduleForExportModal)
